

import React, { createContext, useReducer, useState } from "react";
import { UserReducers } from "../reducers/UserReducers";
import { UserTypes } from "../types/UserTypes";

export const UserContext = createContext()

export function UserProvider(props) {
    const [pkce, setPkce] = useState({ codeVerifier: "", codeChallenge: "" });
    const [datosUsuario, setDatosUsuario ] = useState()
    const decifrado = atob(localStorage.getItem('pm-session') || '')
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    const initialUserState = {
        codUsuario: datosSession.uid || 0,
        nomUsuario: datosSession?.nomUsuario?.toLowerCase() || '',
        token: datosSession.token || datosSession.refresh_token ||  '',
        tokenExpire: datosSession.tokenExpire || 0,
        menus: datosSession.menus || [],
        permisos: datosSession.permisos || [],
        codUsuarioTipo: datosSession.rol || '',
        nomCarpetaFoto: datosSession.nomCarpetaFoto || '',
        nomFoto: datosSession.nomFoto || '',
        uid: datosSession?.uid?.toLowerCase() || ""
    }
    const [ state, dispatch ] = useReducer(UserReducers, initialUserState)
    
    const signIn = (objSession) => {
        var cifrado = btoa(JSON.stringify(objSession));
        localStorage.setItem('pm-session', cifrado);
        setDatosUsuario(objSession)
        dispatch({type: UserTypes.SIGN_IN, payload: objSession})
    }

    const signOut = () => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch({type: UserTypes.SIGN_OUT})
    }

    return (
        <UserContext.Provider value={{stateUser: state, datosUsuario, signIn, signOut}}>
            {props.children}
        </UserContext.Provider>
        
    )
}